export default {
  state: {},
  mutations: {},
  actions: {
    async saveForm ({ commit }, { data, status, type }) {
      try {
        const result = await axios.post('/user/models/create/', {data, status, type})
        return result
      } catch (e) {
        throw e
      }
    },
    async fetchModelData ({commit}, id) {
      try {
        const data = await axios.get('/user/models/getmodel/'+id)
        console.log(data)
        return await axios.get('/user/models/getmodel/'+id).then(res => res.data.data)
      } catch (e) {
        throw e
      }
    },
    uploadFiles ({ commit }, { files, typeFiles }) {
      try {
        const data = new FormData
        files.forEach(file => data.append('files[]', file))
        data.append('type', typeFiles)
        if (typeFiles === 'modelsAr') {
          data.append('qr', true)
        }
        return axios.post('/user/models/upload_files/', data).then(res => res.data)
      } catch (e) {
        throw e
      }
    },
    async checkOnExistName ({}, [val, fieldName = '']) {
      const value = val,
            data  = new FormData(),
            valueIsObject = typeof value === 'object'

      if (fieldName === 'fullName' || valueIsObject) {
        data.append('name', valueIsObject ? value.fullName : value)
      }
      if (fieldName === 'shortName' || valueIsObject) {
        data.append('name_short', valueIsObject ? value.shortName : value)
      }
      if (valueIsObject) {
        data.append('id', value.id)
      }

      try {
        await axios.post('/user/models/checkonexistname/', data)
      } catch (e) {
        throw e
      }
    },
  },
}
